import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { userDashboardAccountSettingsRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { UserDashboardAccountSettingsPageLoadable } from './UserDashboardAccountSettingsPageLoadable';

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof userDashboardAccountSettingsRoute>,
) {
  await UserDashboardAccountSettingsPageLoadable.load();
}

export default function UserDashboardAccountSettingsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Account Settings')}>
      <UserDashboardAccountSettingsPageLoadable />
    </RouteModule>
  );
}
